import React, { FunctionComponent } from 'react';
import { ErrorMessage, RadioGroup } from 'react-design-components';
import { Controller } from 'react-hook-form';
import ControlledFormComponentProps from '../ControlledFormComponentProps';

interface FormData {
  salutation?: string;
}

const SalutationInput: FunctionComponent<ControlledFormComponentProps<FormData>> = ({
  t,
  control,
  errors,
  defaultValue,
}) => {
  return (
    <>
      <Controller
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => (
          <RadioGroup
            onChange={onChange}
            value={value}
            items={[
              {
                value: 'male',
                label: t('male'),
              },
              {
                value: 'female',
                label: t('female'),
              },
            ]}
            marginRight
            row
          />
        )}
        name="salutation"
        control={control}
        rules={{
          required: t('validation.salutation.required') as string,
        }}
      />
      {!!errors.salutation && <ErrorMessage>{errors.salutation.message}</ErrorMessage>}
    </>
  );
};

export default SalutationInput;
